import { Grid } from "@cloudscape-design/components";
import {useContext, useEffect, useState} from "react";
import {
  ALREADY_COLLECTED_COUPON,
  CANNOT_COLLECT_COUPON,
  postCollectPromotionCoupon,
} from "../../api/promotion";
import { CheckIcon } from "../../components/CheckIcon";
import { ErrorIcon } from "../../components/ErrorIcon";
import { NOT_AUTHORIZED } from "../../utils/constants";
import "./Redeem.css";
import {getAuthenticationContext, getIdToken} from "../../auth/AuthenticationContext";

type CodeStatusProps = {
  error: boolean;
};

type RedeemProps = {
  couponId: string;
};

const LOADING_MESSAGE = "Loading your coupon...";
const SUCCESS_MESSAGE = "Go get your goodie inside the game!";
const CANNOT_COLLECT_MESSAGE = "You can't collect this coupon.";
const ALREADY_COLLECTED_MESSAGE = "You have already collected this coupon.";
const NOT_AUTHORIZED_MESSAGE = "You don't have permission to collect a coupon.";
const ERROR_MESSAGE = "Something went wrong at our side :(";

const CodeStatus = ({ error }: CodeStatusProps) => {
  return (
    <div className={`redeem--code-status-wrapper${error ? "--error" : ""}`}>
      {error && (
        <div className="redeem--code-status-icon">
          <ErrorIcon />
        </div>
      )}
      {error ? "ERROR" : "REDEEMED"}
      {!error && (
        <div className="redeem--code-status-icon">
          <CheckIcon />
        </div>
      )}
    </div>
  );
};

export const Redeem = ({ couponId }: RedeemProps) => {
  const AuthenticationContext = useContext(getAuthenticationContext());
  const [message, setMessage] = useState(LOADING_MESSAGE);
  const [hasError, setError] = useState(false);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    AuthenticationContext.checkUserLoggedIn()
      .then(() => {
        const userToken = getIdToken();
        postCollectPromotionCoupon(userToken, couponId)
          .then(() => {
            setMessage(SUCCESS_MESSAGE);
            setLoading(false);
          })
          .catch((err) => {
            setError(true);
            if (err?.message) {
              setMessage(err.message);
            } else if (err === NOT_AUTHORIZED) {
              setMessage(NOT_AUTHORIZED_MESSAGE);
            } else if (err === CANNOT_COLLECT_COUPON) {
              setMessage(CANNOT_COLLECT_MESSAGE);
            } else if (err === ALREADY_COLLECTED_COUPON) {
              setError(false);
              setMessage(ALREADY_COLLECTED_MESSAGE);
            } else {
              console.log(err);
              setMessage(ERROR_MESSAGE);
            }
            setLoading(false);
          });
      })
      .catch(() => {
        setError(true);
        setMessage(CANNOT_COLLECT_MESSAGE);
      });
  }, [couponId]);

  return (
    <>
      <Grid
        gridDefinition={[
          { colspan: { l: 6, m: 6, default: 12 } },
          { colspan: { l: 6, m: 6, default: 0 } },
        ]}
        disableGutters
      >
        <div className="redeem--left-column">
          <div className="redeem--left-column-content">
            {isLoading ? (
              <div className="redeem--title">Loading...</div>
            ) : (
              <>
                <div className="redeem--title">
                  {hasError ? "Ops!" : "There you go!"}
                </div>
                <CodeStatus error={hasError} />
                <div className="redeem--subtext">{message}</div>
              </>
            )}
          </div>
        </div>
        <div className="redeem--right-column">
          <img
            className="redeem--drones-image"
            src="/images/drones.png"
            alt="Three drones"
          />
        </div>
      </Grid>
    </>
  );
};
